import { Inventory, CurrencyName, ResourceName } from '../managers/Inventory';

export interface RewardItem {
  resourceName: CurrencyName | ResourceName;
  amount: number;
}

export class Reward {
  private claimed: boolean = false;

  constructor(public readonly rewards: RewardItem[]) {

  }

  public claim(): void {
    if (!this.claimed) {
      this.claimed = true;
      this.rewards.forEach((item: RewardItem): void => {
        Inventory.getInstance().addAmount(item.resourceName, item.amount);
      });
    }
  }
}